import { useEffect, useState, useTransition } from 'react';

import { getPositions } from './api';
import { PositionDto } from './dto';

export function useLoadPositions(sectionId?: number | null) {
	const [list, setList] = useState<PositionDto[]>([]);
	const [isPending, startTransition] = useTransition();

	useEffect(() => {
		startTransition(async () => {
			const data = await getPositions(sectionId);
			setList(data);
		});
	}, [sectionId]);

	return { list, isPending };
}
